import React                      from 'react'


export const Toolbar: React.FC< { className?: string } > = ( props ) =>
{
  return <div className={ "toolbar pt-3 pl-3 pr-3 flex-row" + (props.className || '') }
              style={{ alignItems: 'flex-end' }}>
       { props.children }
      </div> ;
}
